import React, { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Timeline } from 'react-svg-timeline';
import { useConnection } from '../../../../connection/Application';
import { useParams } from 'react-router';
import { useHistory } from 'react-router-dom';
import { Spin, message } from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import { WebUxPage, WebUxPageContent, WebUxPageItem } from '../../webux-layouts/WebUxPage';
import { InfoView } from '../../../../components/info-view/InfoView';
import Form, { FormSchema } from '../../../../form/Form';
import { FormModal, useFormModal } from '../../../../components/form-modal/FormModal';
import dayjs from 'dayjs';

const dateFormat = (ms: number) => new Date(ms).toLocaleString();

export const UserTeamTimeLine: FC = () => {
  const ref = useRef(null);
  const [events, setEvents] = useState<
    {
      eventId: string;
      laneId: string;
      startTimeMillis: number;
      endTimeMillis: number;
      cycleEndDay: number;
      cycleStartDay: number;
    }[]
  >([]);

  const laneSet = useRef<
    {
      laneId: string;
      label: string;
    }[]
  >([]);
  const eventSet = useRef<
    {
      eventId: string;
      laneId: string;
      startTimeMillis: number;
      endTimeMillis: number;
      cycleEndDay: number;
      cycleStartDay: number;
    }[]
  >([]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [selectedEvents, setSelectedEvents] = useState<
    | {
        eventId: string;
        laneId: string;
        startTimeMillis: number;
        endTimeMillis: number;
        cycleEndDay: number;
        cycleStartDay: number;
      }
    | undefined
  >();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [doj, setDoj] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [refresh, setRefresh] = useState<number>(0);
  const connection = useConnection();
  const params = useParams<{ id: string; name: string }>();
  const history1 = useHistory();
  const editForm =
    useFormModal<{ start: number; end: number; cycleEndDay: number; cycleStartDay: number }>();

  const disabledDate = useCallback((current, min: string, max: string) => {
    if (!current) return false;
    // disable anything before min or after max
    return current.valueOf() < dayjs(min).valueOf() || current.valueOf() > dayjs(max).valueOf();
  }, []);

  const timeLineEditSchema: FormSchema = useMemo(
    () => [
      {
        id: 'start',
        name: 'Join Date',
        type: 'date',
        layout: { span: 12 },
        props: {
          // disabledDate: (current: Dayjs) =>
          //   disabledDate(
          //     current,
          //     dayjs(selectedEvents?.cycleStartDay).format('YYYY-MM-DD') > doj
          //       ? dayjs(selectedEvents?.cycleStartDay).format('YYYY-MM-DD')
          //       : doj,
          //     dayjs(selectedEvents?.cycleEndDay).format('YYYY-MM-DD'),
          //   ),
          future: true,
        },
      },
      {
        id: 'end',
        name: 'End Date',
        type: 'date',
        layout: { span: 12 },
        props: {
          // disabledDate: (current: Dayjs) =>
          //   disabledDate(
          //     current,
          //     dayjs(selectedEvents?.cycleStartDay).format('YYYY-MM-DD') > doj
          //       ? dayjs(selectedEvents?.cycleStartDay).format('YYYY-MM-DD')
          //       : doj,
          //     dayjs(selectedEvents?.cycleEndDay).format('YYYY-MM-DD'),
          //   ),
          future: false,
        },
      },
    ],
    [],
  );

  useEffect(() => {
    setLoading(true);
    laneSet.current = [];
    eventSet.current = [];
    connection
      .get(`goals/timeline/user/${params.id}`)
      .then((result: any) => {
        console.log(result?.response?.doj ?? '');
        setDoj(result?.response?.doj ?? '');
        for (const resultKey in result?.response.result) {
          laneSet.current = [
            ...laneSet.current,
            {
              laneId: result?.response.result[resultKey].team.id + '',
              label: result?.response.result[resultKey].team.title,
            },
          ];
          // setLanes(laneSet.current);
          eventSet.current = [
            ...eventSet.current,
            ...result?.response.result[resultKey].duration.map((e: any) => ({
              eventId: e.id + '',
              laneId: e.teamId + '',
              startTimeMillis: dayjs(e.from).valueOf(),
              endTimeMillis: dayjs(e.to).valueOf(),
              cycleEndDay: dayjs(e.cycleEndDay).valueOf(),
              cycleStartDay: dayjs(e.cycleStartDay).valueOf(),
            })),
          ];
        }
        // setLanes(laneSet.current);
        setEvents(eventSet.current);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [connection, params.id, refresh]);

  return (
    <WebUxPage>
      <PageHeader
        ghost={false}
        style={{ background: '#FFF' }}
        title={`${decodeURIComponent(params?.name ?? '')} TimeLine`}
        subTitle="View TimeLine"
        onBack={() => history1.goBack()}
        breadcrumb={{
          items: [
            {
              path: '',
              title: `TimeLine / ${decodeURIComponent(params?.name ?? '')}`,
            },
          ],
        }}
      />
      <WebUxPageContent>
        <WebUxPageItem>
          <InfoView title={'Zoom In'}>Zoom In: Click</InfoView>
          <InfoView title={'Zoom Out'}>Zoom Out: Alt + Click</InfoView>
          <InfoView title={'Zoom Custom'}>Zoom Custom: Shift + Click + Drag</InfoView>
          <InfoView title={'Pan'}>Pan: Click + Drag</InfoView>
          <InfoView title={'Reset'}>Reset: Esc</InfoView>
          <div ref={ref}>
            <Spin spinning={loading}>
              {/*eslint-disable-next-line @typescript-eslint/ban-ts-comment*/}
              {/*@ts-ignore*/}
              {/*{ref.current.getBoundingClientRect().width}*/}
              {laneSet.current.length !== 0 && (
                <Timeline
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  width={ref.current?.offsetWidth ?? 1000}
                  height={laneSet.current.length * 80 + 50}
                  events={events}
                  laneDisplayMode={'expanded'}
                  lanes={laneSet.current}
                  onEventClick={(d) => {
                    const x = events.find((e) => e.eventId === d);
                    setSelectedEvents(x);
                    console.log(x);
                    editForm.open({
                      start: x?.startTimeMillis,
                      end: x?.endTimeMillis,
                      cycleEndDay: x?.cycleEndDay,
                      cycleStartDay: x?.cycleStartDay,
                    });
                  }}
                  dateFormat={dateFormat}
                />
              )}
            </Spin>
          </div>
          <FormModal
            title={'Edit TimeLine'}
            onSubmit={(e) => {
              connection
                .patch(`goals/timeline/duration/${selectedEvents?.eventId}`, {
                  from: dayjs(e.start).format('YYYY-MM-DD'),
                  to: dayjs(e.end).format('YYYY-MM-DD'),
                })
                .then(() => {
                  message.success('Timeline updated successfully');
                  setRefresh((prev) => prev + 1);
                  editForm.close();
                })
                .catch(() => {
                  message.error('Failed to update timeline');
                });
            }}
            form={editForm}>
            <Form.Items schema={timeLineEditSchema} />
          </FormModal>
        </WebUxPageItem>
      </WebUxPageContent>
    </WebUxPage>
  );
};
